import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings'

export const ProcessingMessageStyled = styled.div({
  backgroundColor: hexColors.white,
  padding: '0.5rem',
  textAlign: 'center',
  width: '100%',
})
